<template>
  <div>
    <a-row :gutter="24" style="width: 100%; margin: 15px 0;">
      <a-col :sm="24" :md="12" :xl="4">
        <!-- <input type="file" @change="onXlsxChange" /> -->
        <a-upload
          v-model:file-list="fileList"
          name="file"
          :multiple="true"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          :before-upload="onXlsxChange"
          style="width: 100px;"
        >
          <a-button>
            <upload-outlined></upload-outlined>
            {{ $t("route.ChooseFiles") }}
          </a-button>
        </a-upload>
      </a-col>
      <a-col :sm="24" :md="12" :xl="20">
        <a-button type="primary" @click="initImport" :disabled="canImport">
          {{ $t("route.Import") }}
        </a-button>
        <a-button type="link" @click="downLoadExcelTemplate()">
          {{ $t("route.DownloadExcelTemplate") }}
        </a-button>
      </a-col>
    </a-row>

    <a-modal
      v-model:visible="showScanner"
      title="Scanner"
      :footer="null"
      wrapClassName="modal-with-height"
      :afterClose="onCloseScanner">
      <div class="loading" >
        <a-space>
          <a-spin size="large" />
        </a-space>
      </div>
      <div v-if="showScanner">
        <StreamBarcodeReader
          @decode="onDecode"
          @loaded="onLoaded"
          ref="BarcodeReader"
        >
        </StreamBarcodeReader>
      </div>
    </a-modal>
    <a-modal v-model:visible="printingModal" :footer="null" wrapClassName="printingModal" >
      <a :href="printingUrl" target="_blank">
        <button>
          {{ $t("listRMA.printPackageListNow") }}
        </button>
      </a>
    </a-modal>
    <!-- <a-modal
      :title="ModelTitle"
      v-model:visible="sendPackageModel"
      @ok="onSendPackage"
      okText="SendPackage"
      :okButtonProps="{ disabled: confirmDisabled, loading: confirmLoading }"
      :afterClose="onCloseSendPackage"
      :footer="ModelFooter"
    >
      <span style="margin-top: 10px"><b>{{ $t("route.TrackingNumber") }}</b></span>
      <a-input-search :placeholder="$t('route.pleaseCheckTrackNumber')" v-model:value="sendNavTrackingNumber" style="padding-left:10px;" @search="showDomesticCurrencyValue" @change="DomesticCurrencyValueChange">
        <template #enterButton>
          <a-button>Check</a-button>
        </template>
      </a-input-search>
      <div v-if="DomesticCurrencyValueModel">
        <div style="display:flex; justify-content: space-around; padding: 10px 0;">
          <span>{{ $t('sendPackageToNAV.TotalQuantity') }}: {{ DomesticCurrencyValueData.length }}</span>
          <span>{{ $t('sendPackageToNAV.TotalValue') }}: {{ totalVlaue }}</span>
        </div>
        <a-table
          :columns="DomesticCurrencyValueColumns"
          :data-source="DomesticCurrencyValueData"
        ></a-table>
      </div>
    </a-modal> -->
    <div class="home">
      <a-row :gutter="24" style="width:100%;">
        <a-col :sm="24" :md="12" :xl="8">
          <span style="margin-top: 10px"><b>{{ $t("route.ScanYourRMAProduct") }}</b></span>
          <a-input-search
            placeholder=""
            v-model:value="productScan"
            @pressEnter="onHandleProductScan"
            enter-button
            @search="onHandleProductScan"
            ref="tnumberInput"
          >
            <template #prefix>
              <a-button type="primary" @click="toggleScanner">
                <template #icon>
                  <ScanOutlined />
                </template>
              </a-button>
            </template>
          </a-input-search>
        </a-col>
        <a-col :sm="24" :md="12" :xl="8">
          <span style="margin-top: 10px"><b>{{ $t("route.TrackingNumber") }}</b></span>
          <a-input-search
            placeholder=""
            v-model:value="trackingNumber"
            style="padding-left:10px"
            ref="rmaNumberInput"
          >
            <template #prefix>
              <BarcodeOutlined/>
            </template>
          </a-input-search>
        </a-col>
        <a-col :sm="24" :md="12" :xl="4">
          <span style="margin-top: 10px"><b>{{ $t("ExpressDelivery.ExpressDeliveryCompany") }}</b></span>
          <a-select
            ref="select"
            v-model:value="ExpressDelivery"
            style="width: 100%;"
          >
            <a-select-option v-for="item in ExpressDeliveryList" :key="item.id" :value="item.carrier_representation">{{ item.carrier_name }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :sm="24" :md="12" :xl="8">
          <span style="margin-top: 10px"><b>{{ $t("route.LargeParcelTrackingNumber") }}</b></span>
          <a-input-search
            placeholder=""
            v-model:value="whLargeParcelTrackingNumber"
            style="padding-left:10px"
            ref="whLargeParcelTrackingNumberInput"
          >
            <template #prefix>
              <BarcodeOutlined/>
            </template>
          </a-input-search>
        </a-col>
        <a-col :sm="24" :md="12" :xl="8" style="text-align: 'center'; margin-top: 23px;">
          <a-button key="blankRMA" type="primary" @click="onPreparePackage" :disabled="!hasScannedItem || trackingNumber === ''" style="margin-right: 20px;">
            <template #icon>
              <PlusOutlined />
            </template>
            {{ $t("route.PreparePackage") }}
          </a-button>
          <!-- <a-button key="blankRMA" type="primary" @click="showSendPackage">
            {{ $t("route.ConfirmToSend") }}
          </a-button> -->
          <a-button type="link" @click="onClickClearAll">
            {{ $t("route.ClearAll") }}
          </a-button>
          <a-button type="link" @click="downLoadExcelReport()">
            {{ $t("route.GenerateExcel") }}
          </a-button>
        </a-col>
      </a-row>
      <a-row>
        <LastProduct :lastItem="lastItem" :unScannedItemCount="UnScannedItemCount" :scannedItemCount="ScannedItemCount"></LastProduct>
      </a-row>
    </div>

    <a-card :body-style="{ padding: '20px 24px 8px' }" :bordered="true">
      <div class="chart-card-header">
        <div class="meta">
          <span class="chart-card-title">
            <slot name="title">
              <span style="color:#FF4D4D;"><b>*{{ $t("route.RedIsUnscannedProduct") }}</b></span> | <span style="color:#86D067;"><b>*{{ $t("route.GreenIsScannedProduct") }}</b></span>
            </slot>
          </span>
        </div>
      </div>
    </a-card>
    <ProductList :waitingPackageData="waitingPackageData" :state="PreparePackageState" ></ProductList>
    <ProductDetail :stateData="PreparePackageState"></ProductDetail>
  </div>
</template>
<script>
  import XLSX from "xlsx"
  import { createVNode, ref, computed, watch, onMounted, nextTick } from 'vue'
  import { Modal, message, notification } from 'ant-design-vue'
  import useRmaRepositories from "@/composables/useRmaRepositories"
  import useTrackingRmaRepositories from "@/composables/warehouse/useTrackingRmaRepositories"
  import { UserOutlined, ScanOutlined, ExclamationCircleOutlined, UserSwitchOutlined, BarcodeOutlined, CalendarOutlined, FileSearchOutlined, BorderlessTableOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons-vue';
  import { formatDate } from '@/utils/utils'
  import { StreamBarcodeReader } from "vue-barcode-reader"
  import ProductList from '@/components/rma/ProductList'
  import LastProduct from '@/components/rma/LastProduct'
  import ProductDetail from '@/components/rma/ProductDetail'
  import PreparePackageState from '../rma/state/PreparePackage'
  import { useI18n } from 'vue-i18n';
  export default {
    components: {
      ProductDetail,
      UserOutlined,
      UserSwitchOutlined,
      BarcodeOutlined,
      CalendarOutlined,
      FileSearchOutlined,
      BorderlessTableOutlined,
      ScanOutlined,
      ProductList,
      LastProduct,
      StreamBarcodeReader,
      PlusOutlined,
      UploadOutlined
    },
    setup() {
      // const { isWorkerLogged } = useLockRepositories()
      const { rmas, getRmaByStoreIDStatus, getRmaForOperation, getRmaForOperationByStatus, updateRmaStatus, printPackageList, generateExcel, getPackageStatus, postSendPackage, getPackageprice, getCarrierList } = useRmaRepositories()
      const waitingPackageData = ref([])
      const scannedItem = ref([])
      const productScan = ref("")
      const lastItem = ref({})
      const showScanner = ref(false)
      const printingUrl = ref("")
      const printingModal = ref(false)
      const { selectedItem } =  PreparePackageState()
      const tnumberInput = ref(null)
      const rmaNumberInput = ref(null)
      const exceldata = ref([])
      const { t ,locale } = useI18n({ useScope: 'global' })
      const BarcodeReader = ref()
      const sendPackageModel = ref(false)
      const sendNavTrackingNumber = ref('')
      const confirmDisabled = ref(true)
      const confirmLoading = ref(false)
      const DomesticCurrencyValueModel = ref(false)
      const DomesticCurrencyValueData = ref([])
      const ModelTitle = ref('')
      const ModelFooter = ref('')
      const ExpressDeliveryList = ref([])
      const ExpressDelivery = ref('')
      const canImport = ref(true);
      const fileList = ref([])
      const DomesticCurrencyValueColumns = [
        {
          title: 'Item',
          dataIndex: 'product_sku',
          key: 'product_sku',
          align: 'center'
        },
        {
          title: 'Size',
          dataIndex: 'product_size',
          key: 'product_size',
          align: 'center'
        },
        {
          title: 'Quantity',
          dataIndex: 'quantity',
          key: 'quantity',
          align: 'center'
        },
        {
          title: 'Value',
          dataIndex: 'declare_value',
          key: 'declare_value',
          align: 'center'
        },
        {
          title: 'Currency',
          dataIndex: 'declare_cur',
          key: 'declare_cur',
          align: 'center'
        },
      ];

      onMounted(() => {
        ModelTitle.value = t('sendPackageToNAV.DomesticCurrencyValue')
        nextTick(() => {
          tnumberInput.value.focus();
        });
      })

      const toggleScanner= () => {
        showScanner.value = !showScanner.value
      }

      const onLoaded = () => {}

      const onCloseScanner = () => {}

      const onDecode = (result) => {
        productScan.value = result
        // console.log("decoded")
        onHandleProductScan()
      }

      watch(showScanner, (newValues, prevValues) => {
        if (!newValues) BarcodeReader.value.codeReader.stopStreams()
      })

      const ScannedItemCount = computed(() => {
        return scannedItem.value.length
      });

      const UnScannedItemCount = computed(() => {
        return  waitingPackageData.value.length - scannedItem.value.length
      });
      const hasScannedItem = computed(() => {
        return scannedItem.value.length > 0
      });
      const trackingNumber = ref("")
      const whLargeParcelTrackingNumber = ref("")

      const init = async () => {
        /*  getRmaForOperation('?status_code=13').then((res)=>{
          waitingPackageData.value = res.data
          console.log(waitingPackageData.value, "waitingPackageData.value")
        }).catch((err)=>{
          console.log(err, "status_codeon Mounted")
        }) */

        const result = await getCarrierList()
        ExpressDeliveryList.value = result.data

        try {
          const shipToStore = await getRmaForOperationByStatus(13)
          const rejected = await getRmaForOperationByStatus(19)
          waitingPackageData.value = [...shipToStore.data, ...rejected.data]
        } catch (error) {
          console.log(error, "status_codeon Mounted")
        }
        // console.log("asdsadasdasdasdasdasfgfgnfhjdgf")
        // console.log(rmas.value)
        // waitingPackageData.value = rmas.value.data
        // console.log(rmas.value.data)
        // waitingPackageData.value = rmas.value.data
        // waitingPackageData.value = rmas.value.data
        // x => x.contactid = searchInvoiceDataResult.invoices[stateInvoice.selectedRowKeys].contactid)[0]
      }

      const reset = () => {
        scannedItem.value = []
        waitingPackageData.value = []
        trackingNumber.value = ''
        productScan.value = ''
        sendPackageModel.value = false
        confirmDisabled.value = true
        confirmLoading.value = false
        init()
      }

      init()
      // APMRMA-000179
      const onHandleProductScan = () => {
        // console.log("productScan", productScan.value)
        productScan.value = productScan.value.replace(' ', '')
        const foundItem = waitingPackageData.value.find((data) => {
          return data.RmaID === productScan.value
        })

        const duplicated = scannedItem.value.find((data) => {
          return data.RmaID === productScan.value
        })

        if (duplicated) {
          notification.error({
            message: 'RMA added',
            description: "RMA already added"
          })
          productScan.value = ""
          return
        }

        if (!foundItem) {
          notification.error({
            message: 'RMA not found',
            description: "Could not find any data in your search"
          })
          productScan.value = ""
          return
        } else {
          notification.success({
            message: 'RMA found',
            description: "RMA added for sending out"
          })
        }

        waitingPackageData.value = waitingPackageData.value.filter((data) => {
          return foundItem.id !== data.id
        })

        foundItem.is_scanned = true
        foundItem.rma_id = foundItem.RmaID
        foundItem.receive_item_date = formatDate(foundItem.receive_item_date)
        foundItem.product_image = "https://imgcdn.apm-monaco.cn/products-images/" + foundItem.product_sku + ".jpg?x-oss-process=image/resize,w_300,h_300/quality,q_76"
        waitingPackageData.value.unshift(foundItem)

        scannedItem.value.push(foundItem)

        lastItem.value = foundItem
        lastItem.value.imgsrc = "https://imgcdn.apm-monaco.cn/products-images/"+lastItem.value.product_sku+".jpg?x-oss-process=image/resize,w_300,h_300/quality,q_76"
        // console.log(hasScannedItem, "foundItem")
        productScan.value = ""
      }

      const onClickClearAll = () => {
        Modal.confirm({
          title: 'Are you sure to cancel the tracking?',
          icon: createVNode(ExclamationCircleOutlined),
          onOk() {
            // reset()
            for (var i=0; i < waitingPackageData.value.length; i++) {
              waitingPackageData.value[i].is_scanned = false
            }
            scannedItem.value = []
          },
          onCancel() {},
        });
      }

      const isTrackingNumberVaild = () => {
        const isnum = !/[^a-z0-9_.@()-]/i.test(trackingNumber.value)
        if (!isnum) {
          return false
        }
        return true
      }

      const onPreparePackage = async () => {
        if (!isTrackingNumberVaild()) {
          notification.error({
            message: 'Please Enter Vaild Tracking Number',
            description: `RMA Update Error, Please tracking cannot contain < > : " / \\ | ? * `
          })
          return
        }

        if (!ExpressDelivery.value) {
          notification.error({
            message: t("ExpressDelivery.PleaseSelectExpressDeliveryCompany")
          })
          return
        }

        Modal.confirm({
          title: 'Would you like to confirm the Package?',
          icon: createVNode(ExclamationCircleOutlined),
          onOk() {
            // console.log('onPreparePackage', trackingNumber.value)
            const arrayOfID = []
            const updateAllRma = scannedItem.value.map(async (row) => {
              arrayOfID.push(row.id)
              const post_data = {
                id: row.id,
                rma_status_id: 14,
                retail_carrier_code: trackingNumber.value,
                wh_carrier_representation: ExpressDelivery.value,
                wh_large_parcel_carrier_code: whLargeParcelTrackingNumber.value
              }
              return await updateRmaStatus(post_data).then((data) => {
                return data
              });
              // return await updateRmaStatus(row.id, 14, trackingNumber.value, ExpressDelivery.value).then((data) => {
              //   return data
              // });
              // reset()
            });
            Promise.all(updateAllRma).then(async (data) => {
              // console.log(data, "update Rma response");
              notification.success({
                message: 'RMA Updated',
                description: "RMA Updated"
              })
              // const can_send = await getPackageStatus(trackingNumber.value, 1)
              // if (can_send) {
                
              // } else {
              //   var result = await printPackageList(arrayOfID)
              //   // window.open(result.data.url, '_blank');
              //   printingUrl.value = result.data.url
              //   printingModal.value = true
              //   reset()
              // }
              const result = await printPackageList(arrayOfID, '', 14)
              printingUrl.value = result.data.url
              printingModal.value = true
              reset()
            }).catch((err) => {
              notification.error({
                message: 'RMA Error',
                description: err
              })
              console.log(err, "error Promise All")
              reset()
            })
          },
          onCancel() {},
        });
      }

      const showSendPackage = () => {
        sendPackageModel.value = true
      }

      const DomesticCurrencyValueChange = () => {
        ModelTitle.value = t('sendPackageToNAV.DomesticCurrencyValue')
        ModelFooter.value = ''
      }

      const showDomesticCurrencyValue = async () => {
        const result = await getPackageprice(sendNavTrackingNumber.value, '1')
        if (result.success) {
          ModelTitle.value = t('sendPackageToNAV.DomesticCurrencyValue')
          ModelFooter.value = ''
          if (result.data.length > 0) {
            DomesticCurrencyValueData.value = result.data
            DomesticCurrencyValueModel.value = true
          } else {
            DomesticCurrencyValueModel.value = false
            notification.error({
              message: t('sendPackageToNAV.dataNotFound')
            })
          }
        } else {
          DomesticCurrencyValueModel.value = false
          if (result.code == 'InvalidParameter.TrackingNoNotSent') {
            confirmDisabled.value = false
            ModelTitle.value = 'Would you like to send the Package?'
            ModelFooter.value = undefined
            // notification.error({
            //   message: "RMA Error",
            //   description: t('InvalidParameter.TrackingNoNotSent')
            // })
          } else {
            notification.error({
              message: "RMA Error"
            })
          }
        }
      }

      const totalVlaue = computed(() => {
        let totalVlaue = 0
        DomesticCurrencyValueData.value.forEach(v => {
          totalVlaue += v.declare_value
        })
        return totalVlaue
      });

      const onSendPackage = async () => {
        // if (!isTrackingNumberVaild()) {
        //   notification.error({
        //     message: 'Please Enter Vaild Tracking Number',
        //     description: `RMA Update Error, Please tracking cannot contain < > : " / \\ | ? * `
        //   })
        //   return
        // }

        // Modal.confirm({
        //   title: 'TrackingNumber can only be sent once, Would you like to send the Package?',
        //   icon: createVNode(ExclamationCircleOutlined),
        //   async onOk() {
        //     const result = await postSendPackage(trackingNumber.value, '1')
        //     if (result.success) {
        //       notification.success({
        //         message: 'RMA Updated',
        //         description: t('InvalidParameter.commonSuccess')
        //       })
        //       var PackageList = await printPackageList([], trackingNumber.value)
        //       printingUrl.value = PackageList.data.url
        //       printingModal.value = true
        //       reset()
        //     } else {
        //       if (result.code != 'InvalidParameter.TrackingNo' && result.code != 'InvalidParameter.Locked' && result.code != 'InvalidParameter.Country') {
        //         return notification.error({
        //           message: 'RMA Error',
        //           description: t('InvalidParameter.commonError')
        //         })
        //       }
        //       notification.error({
        //         message: 'RMA Error',
        //         description: t(`${result.code}`)
        //       })
        //     }
        //     Modal.destroyAll()
        //   },
        //   onCancel() {},
        // });

        confirmLoading.value = true
        const result = await postSendPackage(sendNavTrackingNumber.value, '1')
        if (result.success) {
          notification.success({
            message: 'RMA Updated',
            description: t('InvalidParameter.commonSuccess')
          })
          reset()
        } else {
          confirmLoading.value = false
          if (result.code != 'InvalidParameter.TrackingNo' && result.code != 'InvalidParameter.Locked' && result.code != 'InvalidParameter.Country') {
            return notification.error({
              message: 'RMA Error',
              description: t('InvalidParameter.commonError')
            })
          }
          notification.error({
            message: 'RMA Error',
            description: t(`${result.code}`)
          })
        }
      }

      const onCloseSendPackage = () => {
        sendNavTrackingNumber.value = ''
        confirmDisabled.value = true
        confirmLoading.value = false
        DomesticCurrencyValueModel.value = false
        DomesticCurrencyValueData.value = []
        ModelTitle.value = t('sendPackageToNAV.DomesticCurrencyValue')
        ModelFooter.value = ''
      }

      const downLoadExcelReport = async () => {
        let report_id;
        // console.log(waitingPackageData.value, "waitingPackageData.value")
        const result = await generateExcel(2, waitingPackageData.value)
        if (result.url) {
          window.open(result.url)
        } else {
          // console.log("No url found")
        }
      }

      const downLoadExcelTemplate = () => {
        window.open('https://weappimg.apm-monaco.cn/RMA_resource/RMA_LogisticShipUp_template_V3.xlsx')
      }

      const initImport = async() => {
        if (exceldata.value.length <= 0) return
        const bulkExcelAction= exceldata.value.map((excelvalue) => {
          const isRMAinWaitingList = waitingPackageData.value.find((PackageData) => PackageData.RmaID === excelvalue[0])
          // console.log(isRMAinWaitingList, "isRMAinWaitingList", excelvalue[1], "excelvalue[1]")
          if (isRMAinWaitingList && excelvalue[1].length) {
            // console.log("import action", excelvalue, isRMAinWaitingList.RmaID)
            const post_data = {
              id: isRMAinWaitingList.id,
              rma_status_id: 14,
              retail_carrier_code: excelvalue[1],
              wh_carrier_representation: excelvalue[2],
              wh_large_parcel_carrier_code: excelvalue[3]
            }
            return updateRmaStatus(post_data).then((data) => {
              return {success: true, id: excelvalue[0], data: data}
            }).catch((error) => {
              return {success: false, error: error, id: excelvalue[0]}
            })
            // return updateRmaStatus(isRMAinWaitingList.id, 14, excelvalue[1], excelvalue[2]).then((data) => {
            //   return {success: true, id: excelvalue[0], data: data}
            // }).catch((error) => {
            //   return {success: false, error: error, id: excelvalue[0]}
            // })
          } else {
            // console.log("import fail", excelvalue)
            return  {success: false, error: "Not in List/No Tracking", id: excelvalue[0]}
          }
        })

        try {
          const bulkExcelResponse = await Promise.all(bulkExcelAction)
          var successCount = 0
          bulkExcelResponse.map((res) => {
            if (res.success) {
              successCount +=1
            }
          })
          notification.success({
            message: 'RMA Updated',
            description: successCount + "/" + bulkExcelResponse.length + " of RMA Updated"
          })
          // console.log(bulkExcelResponse, "bulkExcelResponse")
        } catch (error) {
          console.log(error)
        }
      }

      const onXlsxChange = async(event) => {
        // var file = event.target.files ? event.target.files[0] : null;
        let file = event ? event : null;
        fileList.value = [event]
        if (file) {
          canImport.value = true;
          const reader = new FileReader();
          reader.readAsBinaryString(file);
          reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const XLSX_data = XLSX.utils.sheet_to_json(ws, { header: 1 });
            exceldata.value = []
            let data = XLSX_data.filter((v, i) => {
              return i !== 0
            })
            let data_check = -1
            data.forEach(v => {
              if (!v[0] || v[0] == '') data_check = 0
              if (!v[1] || v[1] == '') data_check = 1
              if (!v[2] || v[2] == '') data_check = 2
            })
            if (data_check < 0) {
              exceldata.value = data
              canImport.value = false;
            } else if (data_check == 0) {
              notification.error({
                message: 'RMA Error',
                description: t('ExpressDelivery.PleaseCheckRMAID')
              })
            } else if (data_check == 1) {
              notification.error({
                message: 'RMA Error',
                description: t('ExpressDelivery.PleaseCheckTrackingNumber')
              })
            } else if (data_check == 2) {
              notification.error({
                message: 'RMA Error',
                description: t('ExpressDelivery.PleaseCheckExpressDelivery')
              })
            }
            // console.log(data, "onXlsxChange set value 'exceldata'");
          }
        }
      }

      return {
        waitingPackageData,
        BarcodeOutlined,
        productScan,
        onHandleProductScan,
        hasScannedItem,
        trackingNumber,
        onPreparePackage,
        onSendPackage,
        ScannedItemCount,
        UnScannedItemCount,
        lastItem,
        onClickClearAll,
        onDecode,
        onLoaded,
        StreamBarcodeReader,
        showScanner,
        toggleScanner,
        printingUrl,
        printingModal,
        PreparePackageState,
        tnumberInput,
        rmaNumberInput,
        locale,
        t,
        downLoadExcelReport,
        downLoadExcelTemplate,
        onXlsxChange,
        exceldata,
        initImport,
        onCloseScanner,
        BarcodeReader,
        showSendPackage,
        sendPackageModel,
        sendNavTrackingNumber,
        confirmDisabled,
        confirmLoading,
        onCloseSendPackage,
        DomesticCurrencyValueModel,
        showDomesticCurrencyValue,
        DomesticCurrencyValueData,
        DomesticCurrencyValueColumns,
        totalVlaue,
        ModelTitle,
        ModelFooter,
        DomesticCurrencyValueChange,
        ExpressDeliveryList,
        ExpressDelivery,
        canImport,
        fileList
        // isWorkerLogged
      }
    }
  }
</script>
<style lang="scss" scoped>
.waiting_package_data_row {
  background:#FF4D4D;
}

.waiting_package_data_row.is_scanned {
  background:#86D067;
}
.home::v-deep {
  padding-left: 10px;
  padding-right: 10px;
}

.ant-card .ant-card-body::v-deep {
  padding: 10px!important;
}

.ant-image::v-deep {
  float: right!important;
}

.wrapper2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.badge2 {
  display: inline-block;
  border-radius: 50%;
  font-size: 20px;
  padding: 10px;
  min-width: 55px;
  text-align: center;
  background: #86D067;
  color: #fefefe;
}

.badge3 {
  display: inline-block;
  border-radius: 50%;
  font-size: 20px;
  padding: 10px;
  min-width: 55px;
  text-align: center;
  background: #FF4D4E;
  color: #fefefe;
}

button:disabled::v-deep,
button[disabled]::v-deep {
  border: 1px solid #999999!important;
  background-color: #cccccc!important;
  color: #666666!important;
}

.loading {
  left:46%;
  top:50%;
  position: absolute;
}
</style>
<style lang="scss">
.scanner-container {
  .laser {
    top: 50%;
  }
}
.modal-with-height {
  .ant-modal-body {
    min-height:300px;
  }
}
.ant-input-search-enter-button {
  padding-top: 0px!important;
  padding-left: 0px!important;
  padding-bottom: 0px!important;
}
</style>